import { inject } from '@angular/core';
import type { DefaultContext, TypedDocumentNode } from '@apollo/client/core';
import { Apollo } from 'apollo-angular';
import { map, type Observable } from 'rxjs';
import type { FetchVariables } from './types';

/**
 * static-graphql-documents (D3 clean break): no `fields?` parameter anymore —
 * see `query-find.ts` for the rationale. `TData`/`TKey` are inferred from the
 * passed `TypedDocumentNode` and the literal `key` string.
 */
export function queryGet<TData extends object, TKey extends keyof TData & string = keyof TData & string>(
  statement: TypedDocumentNode<TData, FetchVariables>,
  key: TKey,
  variables?: FetchVariables,
): Observable<TData[TKey]> {
  const apollo = inject(Apollo);

  return apollo
    .query<TData, FetchVariables>({
      query: statement,
      variables,
      context: { headers: variables?.headers } as DefaultContext,
    })
    .pipe(map((result) => result.data?.[key] ?? ([] as TData[TKey])));
}
